var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgWorkCapacity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8613 15.6769V5.22836C20.8613 4.37808 20.2305 3.85693 19.4213 3.85693H5.00849C4.07592 3.85693 3.52734 4.41922 3.52734 5.31065V15.6778H20.8631L20.8613 15.6769Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M9.69922 13C9.97536 13 10.1992 12.7761 10.1992 12.5C10.1992 12.2239 9.97536 12 9.69922 12C9.42308 12 9.19922 12.2239 9.19922 12.5C9.19922 12.7761 9.42308 13 9.69922 13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M12.0992 13C12.3754 13 12.5992 12.7761 12.5992 12.5C12.5992 12.2239 12.3754 12 12.0992 12C11.8231 12 11.5992 12.2239 11.5992 12.5C11.5992 12.7761 11.8231 13 12.0992 13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M14.4992 13C14.7754 13 14.9992 12.7761 14.9992 12.5C14.9992 12.2239 14.7754 12 14.4992 12C14.2231 12 13.9992 12.2239 13.9992 12.5C13.9992 12.7761 14.2231 13 14.4992 13Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57544 15.7202L1.53201 17.9008C1.36744 18.1202 1.28516 18.3534 1.28516 18.6962C1.28516 19.5054 1.94344 19.9854 2.69773 19.9854H21.5977C22.4892 19.9854 23.0103 19.4231 23.0103 18.6962C23.0103 18.3945 22.9143 18.1476 22.736 17.9145L20.816 15.7202"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66016 17.7773H17.5759"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkCapacity);
export default __webpack_public_path__ + "static/media/work-capacity.b98a987ec767627149c816b9f132cb1c.svg";
export { ForwardRef as ReactComponent };